/**
 * @Page APIST
 * @Description [APIST]수신자료관리 - 협력사 정보 연계 - 협력사 자율재고
 **/
 import React, { useState, useEffect, useRef, useCallback  } from "react";
 import Ribbon from '@/components/organisms/Ribbon';
 import ContentXearch from '@/components/organisms/ContentXearch';
 import Content from '@/components/organisms/Content';
 import Grid from '@/components/grid/agGrid';
 import CustomAlert from "@/components/molecules/CustomAlert";
 import AlertDialog from '@/components/material-UI/AlertDialog';
 import * as Common from '@/utils/Common'; 
 import CommonUtil from '@/utils/CommonUtil'; 
 import UploadModal from "@/components/organisms/UploadModal";
 import Loading from "src/components/atoms/CustomLoading2";
  
 const SERVER_URL = process.env.REACT_APP_BACKEND_SERVER; 
 const CODES = require('@/config/commonCode.json');
 const Utils = new CommonUtil();

 
  function APIST() {
 
    const token = Common.getToken();
    const userId = Common.getToken("id");
    const tVnt1 = Common.getToken("vand");
    const tComp = Common.getToken("comp");
    const grdRntc14Main = useRef();
    const [gridApi, setGridApi] = useState(null);
    const ckVnt1 = Common.getCookie("ck_vnt1"+userId)===null||Common.getCookie("ck_vnt1"+userId)===""||Common.getCookie("ck_vnt1"+userId)==="undefined"?tVnt1:Common.getCookie("ck_vnt1"+userId); 
    let [loading, setLoading] = useState(false);
    
      const onGridReady  = (params) => {
        setGridApi(params);
    };
    const [idata, setData] = useState({
        kVnt1 : ckVnt1,
        kComp : tComp,
        kDocd : "",
        kTotcnt : "",
        kVnt1Nm : "",
        kCompNm : tComp==="EHMC"?"현대자동차(주)":"기아자동차(주)",
        kPageNum: 1,
        kPageTotal: 0,
        
        vnt1List : [],
        docdList : [],
    }); 
    
    const [message, setMessage] = React.useState( {
        openAlert : false,      
        severity : "success",   
        msg : ""                
    });
    const { openAlert, severity, msg } = message;
    const [uploadInfo, setUploadInfo] = useState({ vnt1: tVnt1, subDir: "DATA" });

    const [panded, setPanded] = React.useState(true);
    const [style, setStyle] = useState({ height :"calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px)"});
    const [dlgMessage, setDlgMessage] = React.useState( {
        openDlg : false,    
        dlgTrans : "",      
        dlgMsg : ""         
    });
    const { openDlg, dlgTrans, dlgMsg } = dlgMessage;
  
    let [searchApi, setSearchApi] = useState(false); 
    const [openUpload, setOpenUpload] = React.useState(false);

    const onClearApi = useCallback(async (e) => {
        setSearchApi(false);

    }, []);


    /**
     * 공통코드 조회 (조회조건)
     */
    const onSearchCommon = (para, name) => {
        let commonData = idata;

        const fetchData = async (para, name) => {
            let param = encodeURI(para);
            const query = SERVER_URL + "/comcd/search?query=" + param; 
            await fetch(query, { headers: { Authorization: token } })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) 
                    { 
                        commonData[name] = data.data
                        setData({...commonData});
                    }
                })
        }
        fetchData(para, name);
    }

    const onSearchCommon1 = (para, name) => {
        let commonData = idata;

        const fetchData = async (para, name) => {
            let param = encodeURI(para);
            const query = SERVER_URL + "/comcd/search?query=" + param; 
            await fetch(query, { headers: { Authorization: token } })
                .then((resp) => resp.json())
                .then((data) => {
                    if (data.success) 
                    { 
                    commonData[name] = data.data[0].text;
                    setData({...commonData});
                    }
                })
        }
        fetchData(para, name);   
    }

    useEffect( () => {
        
        //공통코드 (T1업체)
        onSearchCommon(`{"pgmid":"VNT1"}`, "vnt1List");
        //공통코드 (문서코드)
        // onSearchCommon(`{"pgmid":"WEEK_MATE","Key1":"*", "kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}"}`, "docdList");
        onSearchCommon1(`{"pgmid":"WRCVAND","kVnt1":"${idata.kVnt1}"}`, "kVnt1Nm");
    }, []);

    /**
     * Control 변경 Event
     * @param {*} e 
     */
    const onChange = async (e) => {
        const { name, value, desc } = e.target;

        let newSearchs = idata; 
        let newUploadInfo = uploadInfo;
        newSearchs[name] = value;
        newSearchs[name+"Nm"] = desc;
        
        setData({ ...newSearchs });

        if (name === "kVnt1")  {
            newSearchs["kDocd"] = "";
            newSearchs["kPageNum"] = 1;
            newUploadInfo["vnt1"] = value;

            setData({ ...newSearchs });
            setUploadInfo({ ...newUploadInfo });

            onSearchCommon(`{"pgmid":"CONS_SALE","Key1":"*", "kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}"}`, "docdList");
        }
        if(name==="kComp"){
            newSearchs["kCompNm"] = value==="EHMC"?"현대자동차(주)":"기아자동차(주)";
            newSearchs["kDocd"] = "";
            setData({ ...newSearchs });

            onSearchCommon(`{"pgmid":"CONS_SALE","Key1":"*", "kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}"}`, "docdList");
        }
         if( name === "kDocd"){
            newSearchs["kPageNum"] = 1;
            setData({ ...newSearchs });
        }


        onSearch()
    }

    /**
     * Grid Event 
     * @param {*} e 
     */
    const grdRntc14Main_onCellValueChanged = async (e) => {
    }
    const grdRntc14Main_onRowClicked = async (e) => {
    }

    /**
     * 검색조건
     */
    const optionsX = {
        0: [
            //T1업체
            {
                "formatter": "select", "name": "kVnt1", "labelName": "1차업체", "type": "text", "defaultValue": idata.kVnt1,  
                "codeMode": true,
                "selectAll": "",
                "codes": null,
                "comms": idata.vnt1List,
                "align": "left", 
            }, 
            //회사구분,
            {
                "formatter": "select", "name": "kComp", "labelName": "회사구분", "type": "text", "defaultValue": idata.kComp,  
                "codeMode": false,
                "selectAll": "",
                "codes": CODES["comp"],
                "comms": null,
                "align": "left", 
            }, 
            //문서코드
            /* {
                "formatter": "select", "name": "kDocd", "labelName": "문서코드", "type": "text", "defaultValue": idata.kDocd,  
                "codeMode": false,
                "selectAll": false,
                "codes": [{comCode: "", text: "문서 전체"}],
                "comms": idata.docdList,
                "align": "right", 
            },  */
             //전체건수
             {
                "formatter": "input", "name": "kTotcnt", "labelName": "전체건수", "type": "text", "defaultValue": idata.kTotcnt, "readOnly" : true,
                "codeMode": false,
                "selectAll": "none",
                "codes": null,
                "comms": "",
                "align": "right", 
            }, 
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" },
            {"formatter": "blank", "align": "right" }
        ]
    }

    /**
     * 조회 
     * @param {*} e 
     * @returns 
     */
    const onSearch = async (e) => {

        //T1업체선택 Check
        if (idata.kVnt1 == "")
        {
            setMessage({ openAlert : true, 
                        severity : "info",
                        msg : "1차업체를 선택하십시요 !"});
            document.getElementById("kVnt1").focus();                         
            return ;
        }

        //회사구분선택 Check
        if (idata.kComp == "")
        {
            setMessage({ openAlert : true, 
                         severity : "info",
                         msg : "회사구분을 선택하십시요 !"});
            document.getElementById("kComp").focus();                         
            return ;
        }

        // Cookie 값 셋팅
        Common.setCookie("ck_vnt1"+userId,idata.kVnt1,1);

        const page = "INF_CONS_SALE_STAT"
        let para = `{
                        "kGubn":"${page}",
                        "kVnt1": "${idata.kVnt1}", "docd": "${idata.kDocd}", "kComp": "${idata.kComp}","kPtno":"${idata.kPtno}",
                        "kPageNum":"${idata.kPageNum}"
                    }`;
        let param = encodeURI(para);

        const query = SERVER_URL + "/AutoReceiver/WeeklyMaterialReq/search?query=" + param;
        setSearchApi(query);
    }

    /**
    * 파일생성
    * @param {*} e 
    */
    const onUpload = async (e) => {
        let newSearchs = idata; 

        newSearchs["vnt1"] = idata.kWrcVand;
        setData({ ...newSearchs });

        setOpenUpload(true);
    }

    const handleUploadClickOpen = () => {

    setOpenUpload(true);
    };

    const handleUploadClose = () => {
    setOpenUpload(false);

    };

    /**
     * 엑셀
     * @param {*} e 
     */
    const onExcel = async (e) => {
        const page = "WEEK_MATE"
        let para = `{"kDocument":"주별소요량",
                     "kGubn":"${page}","kVnt1":"${idata.kVnt1}","kComp":"${idata.kComp}","kDocd":"${idata.kDocd}",
                     "vnt1Nm":"${idata.kVnt1Nm}","compNm":"${idata.kCompNm}","docdNm":"${idata.kDocd===""?"전체":idata.kDocd}","kTotcnt": "${idata.kTotcnt}"}`;
        
        let param = encodeURIComponent(para);
        const query = SERVER_URL + "/AutoReceiver/excel?query=" + param;
        setLoading(true);
        await fetch(query, {headers: {Authorization: token } })
            .then((resp) =>{
                return resp.blob();
            }).then((blob)=>{
                const href = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = href;
                link.setAttribute('download', '주별소요량.xls');
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
            }).catch((err) => {
                return Promise.reject({ Error: 'error', err });
            })
        setLoading(false);

        // 엑셀파일 생성 메세지
        setMessage({ openAlert : true, 
                    severity : "success",
                    msg : "엑셀파일이 생성되었습니다."});
        
    }
    
    //Transaction AlertDialogResult
    const AlertDialogResult = async (e) => {

        //AlertDialog 초기화
        setDlgMessage({ openDlg : false,  dlgTrans : "", dlgMsg : ""});

        //DialogResult
        if (e.result == "N") return;

        //Transaction 구분
        switch (e.Trans) 
        {
            //등록
            case "I" :
                break;
            //수정
            case "U" :
                break;
            //삭제
            case "D" :
                break;

            case "D3" :
                break;
        }
    }
        
    //조회건수
    const onSetCount = (e) => {
        let cnt;
        if(gridApi.api.rowRenderer.gridApi.rowModel.rowsToDisplay.length > 0){
            cnt = gridApi.api.rowRenderer.gridApi.rowModel.rowsToDisplay[0].data.cnt;
        }else{
            cnt = 0;
        }
        let newSearchs = idata; 

        if(idata.kPageNum === 1){
            newSearchs["kPageTotal"] = Math.ceil(parseInt(cnt)/500);
            newSearchs["kTotcnt"] = Common.getNumberFormatter(cnt);
            setData({ ...newSearchs });
        }   
    }
        
    /**
     *Grid Column 정의 
    */
     const columnDefs = [
        { headerName: "품번", field: "MATNR", sortable: true, filter: true, flex: 0,maxWidth: 120, minWidth: 40, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignL"], singleClickEdit: true ,valueGetter: Utils.partnoGetter, hide: false },
        { headerName: "계획일자", field: "DISPD", sortable: true, filter: true, flex: 0, maxWidth: 90,minWidth: 40, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true ,valueFormatter: Utils.dateFormatter, hide: false },
        { headerName: "공장", field: "WERKS", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "공장명", field: "ZPNTNM", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "업체", field: "LIFNR", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "SHOP구분", field: "ZCSHOP", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "라인코드", field: "ZCLLC", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "모델코드", field: "ZCCAR", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true, hide: false },
        { headerName: "MITU수량", field: "ZQMITU", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "WBS수량", field: "ZQWBS", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "거부수량", field: "ZQPRJ", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "PBS수량", field: "ZQPBS", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "WIP", field: "ZQWIP", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true, hide: false },
        { headerName: "주간시작일자", field: "ZWKFM", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true ,valueFormatter: Utils.dateFormatter, hide: false },
        { headerName: "주간마지막일자", field: "ZWKTO", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignC"], singleClickEdit: true ,valueFormatter: Utils.dateFormatter, hide: false },
        { headerName: "W+00 요구수량", field: "ZQW01", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+01 요구수량", field: "ZQW02", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+02 요구수량", field: "ZQW03", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+03 요구수량", field: "ZQW04", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+04 요구수량", field: "ZQW05", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+05 요구수량", field: "ZQW06", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+06 요구수량", field: "ZQW07", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+07 요구수량", field: "ZQW08", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+08 요구수량", field: "ZQW09", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+09 요구수량", field: "ZQW10", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+10 요구수량", field: "ZQW11", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+11 요구수량", field: "ZQW12", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+12 요구수량", field: "ZQW13", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+13 요구수량", field: "ZQW14", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+14 요구수량", field: "ZQW15", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+15 요구수량", field: "ZQW16", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+16 요구수량", field: "ZQW17", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+17 요구수량", field: "ZQW18", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+18 요구수량", field: "ZQW19", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+19 요구수량", field: "ZQW20", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false },
        { headerName: "W+20 요구수량", field: "ZQW21", sortable: true, filter: true, flex: 1, minWidth: 120, editable: false, headerClass: "", cellClass: ["nocheckbox", "alignR"], singleClickEdit: true ,valueFormatter: Utils.numberFormatter, hide: false }
    
    ];

    const onClick = async (e) => {
        setPanded(!panded);

        if(panded===true){
            setStyle({       
                height :"calc(100vh - 65px - 35px - 50px - 21px - 8px)"
            });
        }else{
            setStyle({
                height :"calc(100vh - 65px - 35px - 50px - 21px - 56px - 8px)"
            });
        }
    }
    return(
        <>
            <AlertDialog open={openDlg}  trans={dlgTrans} message={dlgMsg} onClose={AlertDialogResult} />

            <CustomAlert open={openAlert} severity={severity} duration={3000} message={msg} onClose={()=> {setMessage({openAlert:false, severity:"", msg:"조회 실패"})}} anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }} />

            <UploadModal
                open={openUpload}
                onClose={handleUploadClose} 
                onClickOpen={handleUploadClickOpen}
                title={"CSV 업로드"}
                fileId={"APIST"}
                filePath={"C:\\HKC\\VAN\\APIST.CSV"}
                uploadInfo={uploadInfo}
                accp=".csv"
                maxFiles={1}
                validatorName={"csv"}
                uploadApi={SERVER_URL + "/erp/upload1"}
                data={idata.vnt1List}
            />
            <Loading loading={loading} />

            <Ribbon
                onInfoManual={false}
                onSearch={onSearch} onSearchName={null} //조회
                //onExcel={onExcel} onExcelName ={null}   //Excel
                // onUpload={onUpload} onUploadName={"생성"}//생성 
                onExcel={onExcel} onExcelName ={null}   //Excel
            >
                {"수신자료관리 > 협력사 정보 연계 > "}<b style={{ color: "#cd5c5c", fontFamily: "PretendardLight, NanumGothic, sans-serif" }}>협력사 자율재고</b>
            </Ribbon>


            <ContentXearch
                optionsX={optionsX}
                onChange={onChange}
                onClick={onClick} />


            <Content style={style}> 
                <div className={"grid_type01"} >
                    <div className={"grid_wrap01"}> 
                        <div className="grid_cont_box" style={{ height: "calc(100%)" }}>
                            <Grid
                                ref={grdRntc14Main}
                                gridId={"APIST"}                 
                                columnDefs={columnDefs}           
                                pagination={true}                 
                                paginationCsv={false}             
                                onGridReadyEvent={onGridReady}
                                paginationPageSize={"500"}        
                                rowMultiSelectWithClick={true}    
                                suppressRowClickSelection={true}  
                                rowSelection={"multiple"}         
                                enableRangeSelection={false}      
                                enableCellTextSelection={true}    
                                isFirst={false}                   
                                displayNo = {false}
                                searchApi={searchApi} 
                                onClearApi={()=> {onSetCount();onClearApi()}}
                                onCellValueChangedEvent={grdRntc14Main_onCellValueChanged}
                                onRowClickEvent={grdRntc14Main_onRowClicked}
                            />
                        </div>
                    </div>
                </div>
            </Content>
        </>
    )
  }
  export default APIST;